import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import ScrollRestoration from "@/components/ScrollRestoration";
import Index from "./pages/Index";

// Lazy load non-critical routes to reduce initial bundle size
const Ventures = lazy(() => import("./pages/Ventures"));
const VentureDetail = lazy(() => import("./pages/VentureDetail"));
const Ecosystem = lazy(() => import("./pages/Ecosystem"));

const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const About = lazy(() => import("./pages/About"));
const Videos = lazy(() => import("./pages/Videos"));
const Openbox = lazy(() => import("./pages/Openbox"));
const OpenboxAuth = lazy(() => import("./pages/OpenboxAuth"));
// Library page removed - button kept in header
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => {

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <ScrollRestoration />
            <Suspense fallback={<div className="min-h-screen bg-background" />}>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/ventures" element={<Ventures />} />
                <Route path="/ventures/:slug" element={<VentureDetail />} />
                <Route path="/ecosystem" element={<Ecosystem />} />
                
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/about" element={<About />} />
                <Route path="/videos" element={<Videos />} />
                <Route path="/openbox" element={<Openbox />} />
                <Route path="/openbox/auth" element={<OpenboxAuth />} />
                
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
        </TooltipProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
};

export default App;
